'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

BaseTwoAxisGraphPanelDirective=function(_BaseControllerBacked){_inherits(BaseTwoAxisGraphPanelDirective,_BaseControllerBacked);function BaseTwoAxisGraphPanelDirective(){_classCallCheck(this,BaseTwoAxisGraphPanelDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(BaseTwoAxisGraphPanelDirective,[{key:'controller',get:function()
{return BaseTwoAxisGraphPanelDirectiveController}},{key:'objectBindings',get:function()
{return['context','graphYAxisDomain','graphXAxisDomain','preventAnimations']}},{key:'textBindings',get:function()
{return['yAxisLabel']}},{key:'template',get:function()
{
return`<svg id="{{::controller.panelId}}"></svg>`;
}}]);return BaseTwoAxisGraphPanelDirective}(BaseControllerBackedDirective);


const MinimumComponentWidth=181;
const MinimumComponentHeight=98;let

BaseTwoAxisGraphPanelDirectiveController=function(){
function BaseTwoAxisGraphPanelDirectiveController($scope,$timeout,$element,elementService){var _this2=this;_classCallCheck(this,BaseTwoAxisGraphPanelDirectiveController);
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
this._elementService=elementService;
this._svgContainer=null;
this._drawTickLinesOnTopOfGraph=_.get(this,'_drawTickLinesOnTopOfGraph',!1);

this.preventAnimations=_.get(this,'preventAnimations',!1);
this.panelId='panel-'+Guid.create().toString();

this._panelBodyPadding={
top:8,
right:8,
bottom:4,
left:8};

this._axisLabelMargins={
top:4,
right:8,
bottom:18,
left:35};

this._graphAreaInnerPadding={
top:0,
right:0,
bottom:0,
left:8};



this._debouncedRedraw=_.debounce(function(options){return $timeout(function(){return _this2._redraw(options)})},100);

$scope.$on('resize::resize',function(){return _this2._debouncedRedraw({isResizing:!0})});
$scope.$watch('controller.context',function(newVal,oldVal){
if(!_.exists(newVal)||newVal===oldVal){
return;
}

_this2._debouncedRedraw();
});


this._debouncedRedraw();
}BaseTwoAxisGraphPanelDirectiveController.prototype.

_redraw=function _redraw(){let{isResizing=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
if(isResizing||!_.exists(this.graphAreaDimensions)){
this._updateDimensions();

if(isResizing&&_.exists(this.graphAreaDimensions)){
if(this.graphAreaWithMarginDimensions.height===this._lastHeight&&
this.graphAreaWithMarginDimensions.width===this._lastWidth){
return;
}

this._lastHeight=this.graphAreaWithMarginDimensions.height;
this._lastWidth=this.graphAreaWithMarginDimensions.width;
}
}

this.__setupGraphs(isResizing);
this._setupInitialState(isResizing);
this._updateState(isResizing);
};BaseTwoAxisGraphPanelDirectiveController.prototype.

_setupInitialState=function _setupInitialState(){
throw new Error('Abstract!');
};BaseTwoAxisGraphPanelDirectiveController.prototype.

_updateState=function _updateState(){
throw new Error('Abstract!');
};BaseTwoAxisGraphPanelDirectiveController.prototype.





_updateDimensions=function _updateDimensions(){
const ComponentWidth=Math.max(MinimumComponentWidth,this.graphElement.clientWidth)-this._panelBodyPadding.left-this._panelBodyPadding.right;
const ComponentHeight=Math.max(MinimumComponentHeight,this.graphElement.clientHeight)-this._panelBodyPadding.top-this._panelBodyPadding.bottom;

this.graphAreaWithMarginDimensions={
height:ComponentHeight,
width:ComponentWidth};


this.graphAreaDimensions={
height:this.graphAreaWithMarginDimensions.height-this._axisLabelMargins.top-this._axisLabelMargins.bottom,
width:this.graphAreaWithMarginDimensions.width-this._axisLabelMargins.left-this._axisLabelMargins.right};

};BaseTwoAxisGraphPanelDirectiveController.prototype.

__setupGraphs=function __setupGraphs(isResizing){
if(!_.exists(this._svgContainer)){
this._svgContainer=d3.select(`#${this.panelId}`);

this._svgDefs=this._svgContainer.append('defs');

this._graphAreaClipPathRect=this._svgDefs.
append('g').
attr({
class:'clip-path-group',
transform:`translate(${this._axisLabelMargins.left},${this._axisLabelMargins.top})`}).

append('clipPath').
attr({
id:`clip-path-${this.panelId}`}).

append('rect');

this._graphAreaBackground=this._svgContainer.append('rect').
attr({class:'background',transform:`translate(${this._axisLabelMargins.left},${this._axisLabelMargins.top})`});

this._yAxisGroup=this._svgContainer.append('g').
attr({class:'y axis'});

this._xAxisGroup=this._svgContainer.append('g').
attr({class:'x axis'});

this._yAxisLabelGroup=this._svgContainer.append('g').
attr({class:'y axis unit-label'});

this._graphAreaGroup=this._svgContainer.insert('g',this._drawTickLinesOnTopOfGraph?'.y.axis':void 0).
attr({class:'graph-area'}).
attr('transform',`translate(${this._axisLabelMargins.left},${this._axisLabelMargins.top})`);

this._yAxisLabel=this._yAxisLabelGroup.append('text').text(this.yAxisLabel);
}

this._svgContainer.
attr(this.graphAreaWithMarginDimensions).
style('width',`${this.graphAreaWithMarginDimensions.width}px`).
style('height',`${this.graphAreaWithMarginDimensions.height}px`);

this._graphAreaClipPathRect.attr(this.graphAreaDimensions);

this._yScale=d3.scale.linear().
domain(this.graphYAxisDomain).
nice(this._yScaleNiceDomainRounding).
range([this.graphAreaDimensions.height-this._graphAreaInnerPadding.top,this._graphAreaInnerPadding.bottom]).
clamp(!0);

this._xScale=d3.time.scale.utc().
domain(this.graphXAxisDomain).
range([this._graphAreaInnerPadding.left,this.graphAreaDimensions.width-this._graphAreaInnerPadding.right]);

if(_.isFunction(this._setupGraphs)){
this._setupGraphs(isResizing);
}

const graphYAxis=d3.svg.axis().
scale(this._yScale).
orient('left').
ticks(this._numYAxisTicks).
tickPadding(5).
tickSize(this.graphAreaDimensions.width);
this._yAxisGroup.call(graphYAxis);
this._graphAreaBackground.attr(this.graphAreaDimensions);

this._yAxisLabel.attr({
x:0.5*(this.graphAreaDimensions.height-this._axisLabelMargins.bottom),
y:0});


const graphXAxis=d3.svg.axis().
scale(this._xScale).
orient('bottom').
ticks(d3.time.month.utc).
tickPadding(5).
tickFormat(d3.time.format.utc('%b'));
this._xAxisGroup.call(graphXAxis);

this._shiftLayersToCorrectPosition();
};BaseTwoAxisGraphPanelDirectiveController.prototype.

_shiftLayersToCorrectPosition=function _shiftLayersToCorrectPosition(){
this._xAxisGroup.
attr({transform:`translate(${this._axisLabelMargins.left},${this.graphAreaDimensions.height})`});

this._yAxisGroup.
attr({transform:`translate(${this.graphAreaDimensions.width+this._axisLabelMargins.left},${this._axisLabelMargins.top})`});

this._yAxisLabelGroup.
attr({transform:`translate(8,${this.graphAreaDimensions.height}),rotate(-90)`});
};_createClass(BaseTwoAxisGraphPanelDirectiveController,[{key:'graphElement',get:function(){return this._graphElement||(this._graphElement=this._elementService.selectElement(this._$element)[0])}},{key:'minComponentWidth',get:function()

{
return MinimumComponentWidth;
}},{key:'minComponentHeight',get:function()

{
return MinimumComponentHeight;
}}]);return BaseTwoAxisGraphPanelDirectiveController}();


module.exports=BaseTwoAxisGraphPanelDirective;
module.exports.DirectiveController=BaseTwoAxisGraphPanelDirectiveController;
//# sourceMappingURL=baseTwoAxisGraphPanelDirective.js.map
